import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import './styles/index.css';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AddressContextProvider } from './components/map/Address';
// import reportWebVitals from './reportWebVitals';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import LogRocket from 'logrocket';

const hsidValue = uuidv4();
Cookies.set('HSID', hsidValue, { expires: 7, secure: true });

LogRocket.init('specs/specs');

ReactDOM.render(
  <React.StrictMode>
    <AddressContextProvider>
      <App />
    </AddressContextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// reportWebVitals();
